var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyGenderFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C10.7614 1 13 3.22739 13 5.97501C13 8.53071 11.0631 10.6353 8.57031 10.917V11.8799H9.49512C9.80992 11.8799 10.0654 12.1342 10.0654 12.4474C10.0654 12.7606 9.80992 13.0149 9.49512 13.0149H8.57031V14.4325C8.57031 14.7458 8.3148 15 8 15C7.6852 15 7.42969 14.7458 7.42969 14.4325V13.0149H6.49512C6.18031 13.0149 5.9248 12.7606 5.9248 12.4474C5.9248 12.1342 6.18031 11.8799 6.49512 11.8799H7.42969V10.917C4.93688 10.6353 3 8.53071 3 5.97501C3 3.22739 5.23858 1 8 1ZM8 2.13395C5.86818 2.13395 4.13965 3.85385 4.13965 5.97501C4.13965 8.09618 5.86818 9.81607 8 9.81607C10.1318 9.81607 11.8604 8.09618 11.8604 5.97501C11.8604 3.85385 10.1318 2.13395 8 2.13395Z",
    fill: "#D455A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyGenderFemale);
export default __webpack_public_path__ + "static/media/family-gender-female.eb6bbffe2a2df3daf96eb883f3c4df95.svg";
export { ForwardRef as ReactComponent };